/* eslint no-restricted-globals: ["off", "history"] */
import { throttle } from 'underscore';
import jump from 'jump.js';
import Component from '../../../scripts/utilities/component';

class ContentTabs extends Component {
    componentDidMount() {
        const maxWidth = 1023; // viewport width
        this.mobNavOffset = 0; // mobile offset - offset tabs nav position on scroll
        this.dtNavOffset = 50; // desktop offset - offset tabs nav position on scroll
        this.mobScrollOffset = -50; // mobile offset - offset 'scroll to' position on tab change
        this.dtScrollOffset = -80; // desktop offset - offset 'scroll to' position on tab change
        this.winInner = window.innerWidth;
        this.mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
        this.navScrollOffset = this.winInner < maxWidth ? this.mobNavOffset : this.dtNavOffset;
        this.scrollOffset = this.winInner < maxWidth ? this.mobScrollOffset : this.dtScrollOffset;
        this.isSticky = false;
        this.tabPanels = [...this.root.querySelectorAll('[data-ref="panel"]')];
        this.tabLinks = [...this.root.querySelectorAll('[data-ref="link"]')];
        this.tabsLength = this.tabLinks.length;
        this.currentTab = 1;

        this.bindEventListeners();
        this.setAccessibilityControls();
        this.checkHash();
    }

    bindEventListeners() {
        this.tabLinks.forEach((link) => {
            link.addEventListener('keydown', this.handleKeyboardControls.bind(this));
            link.addEventListener('click', this.handleClick.bind(this));
        });

        if (this.root.classList.contains('enable-sticky')) {
            this.isSticky = true;
            const onScrollEvent = throttle(this.onDocumentScroll.bind(this), 50);

            window.addEventListener('scroll', onScrollEvent);

            this.mq.addListener((mql) => {
                if (mql.matches) {
                    this.navScrollOffset = this.mobNavOffset;
                    this.scrollOffset = this.mobScrollOffset;
                } else {
                    this.navScrollOffset = this.dtNavOffset;
                    this.scrollOffset = this.dtScrollOffset;
                }
            });
        }
    }

    setAccessibilityControls() {
        this.tabLinks.forEach((link, i) => {
            link.setAttribute('data-tab-number', i + 1);

            if (link.classList.contains('is--active')) {
                link.setAttribute('aria-selected', true);
            } else {
                link.setAttribute('tabindex', '-1');
            }
        });
    }

    handleKeyboardControls(e) {
        const el = e.target;

        if (e.keyCode === 37) {
            if (this.currentTab === 1) {
                this.tabLinks[this.tabsLength - 1].click();
            } else {
                const prevElem = el.previousElementSibling;
                prevElem.click();
            }
        }

        if (e.keyCode === 39) {
            if (this.currentTab === this.tabsLength) {
                this.tabLinks[0].click();
            } else {
                const nextElem = el.nextElementSibling;
                nextElem.click();
            }
        }
    }

    handleClick(e) {
        e.preventDefault();
        const el = e.currentTarget;
        const tabID = el.href.split('#')[1];
        let panelID;

        this.tabLinks.forEach((link) => {
            link.classList.remove('is--active');
            link.removeAttribute('aria-selected');
            link.setAttribute('tabindex', '-1');
        });

        this.tabPanels.forEach((panel) => {
            const currentPanel = panel.getAttribute('data-panel-id');
            if (tabID === currentPanel) {
                panelID = currentPanel;
            }
            panel.classList.remove('is--active');
        });

        const selectedPanel = this.root.querySelector(`[data-panel-id="${panelID}"]`);

        el.classList.add('is--active');
        el.setAttribute('aria-selected', 'true');
        el.removeAttribute('tabindex');
        el.focus();

        this.currentTab = parseInt(el.getAttribute('data-tab-number'), 10);

        selectedPanel.classList.add('is--active');
        window.location.hash = `#${tabID}`;

        if (this.isSticky && this.root.classList.contains('is--sticky')) {
            jump('.content-tabs__panel', {
                offset: this.scrollOffset
            });
        }
    }

    checkHash() {
        const windowHash = window.location.hash;

        if (windowHash) {
            this.tabLinks.forEach((link) => {
                const hashRef = link.getAttribute('href');

                if (windowHash === hashRef) {
                    link.removeAttribute('tabindex');
                    link.click();

                    this.currentTab = parseInt(link.getAttribute('data-tab-number'), 10);

                    jump('.content-tabs__panel', {
                        offset: this.scrollOffset
                    });
                } else {
                    link.setAttribute('tabindex', '-1');
                }
            });
        }
    }

    onDocumentScroll() {
        const topNav = this.root.offsetTop + this.navScrollOffset;
        this.stickyTabsActive = window.pageYOffset > topNav;

        this.toggleStickyNav();
    }

    toggleStickyNav() {
        if (this.stickyTabsActive) {
            this.root.classList.add('is--sticky');
        } else {
            this.root.classList.remove('is--sticky');
        }
    }
}

export default ContentTabs;



// WEBPACK FOOTER //
// ./components/eng-ms-content-tabs/scripts/content-tabs.js